import React, { useState } from 'react';
import s from './HomePageShimmer.module.scss';
import StoreTab from '../../uiComponents/StoreTab';
import { useRouter } from 'next/router';
import vibrate from 'core-lib/utils/vibration';
import cn from 'classnames';
import Searchbar from '../../uiComponents/Searchbar';
import StoreAppBar from '../../uiComponents/StoreAppBar';
import AnimatedImage from 'core-lib/components/AnimatedImage';
import { THEME } from '../../constants';

type HomePageShimmerPropType = {
  showHalf?: boolean;
  backgroundData?: any;
  searchSuggestions?: [];
};
export const HomePageShimmer = ({
  showHalf = false,
  backgroundData,
  searchSuggestions,
}: HomePageShimmerPropType) => {
  // declarations
  const router = useRouter();

  const activeTab = router?.query?.active_tab ? +router.query.active_tab : 0;

  // state

  return (
    <div className={s.root}>
      <div>
        {!showHalf && (
          <>
            <StoreAppBar
              title="Store"
              showCart
              showBackGroundColor={backgroundData?.theme !== THEME.DARK}
              showAddressBar
              renderAppBarOnly
              isSticky
              themeColor={backgroundData?.theme}
              statusBarColor={backgroundData?.status_color}
            />
            {backgroundData?.header_image && (
              <div className={s.headerImage}>
                <AnimatedImage src={backgroundData?.header_image} />
              </div>
            )}
            <Searchbar searchSuggestions={searchSuggestions} />
            <StoreTab
              curIndex={activeTab}
              setCurIndex={(newIndex: number) => {
                vibrate();
                router.replace({
                  pathname: router.pathname,
                  query: {
                    ...router.query,
                    active_tab: newIndex,
                  },
                });
              }}
            />
          </>
        )}

        <div className={s.box}>
          <div className={cn(s.boxItem, 'cmn_shimmer')}></div>
        </div>

        <div className={s.listingContainer}>
          <div className={cn(s.item, 'cmn_shimmer')}></div>
          <div className={cn(s.item, 'cmn_shimmer')}></div>
          <div className={cn(s.item, 'cmn_shimmer')}></div>
          <div className={cn(s.item, 'cmn_shimmer')}></div>
          <div className={cn(s.item, 'cmn_shimmer')}></div>
        </div>

        <div className={cn(s.bannerListing, 'cmn_shimmer')}></div>
      </div>
      <div className={cn(s.weekendListing, 'cmn_shimmer')}></div>
    </div>
  );
};
